import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logowhite.png";
import FooterData from "../../data/Footer/footerItem.json";
import FooterLinkItem from "../../components/Footer/FooterLinkItem.jsx";

const Footer = () => {
  return (
    <div
      className="footer-section section"
      style={{
        // background:
        // "url(https://www.bizvibez.com/wp-content/uploads/2019/10/asa-1.jpg) no-repeat center/cover",
        backgroundColor: "#042638",
      }}
    >
      <div className="container">
        <div className="row mb-lg-1 mb-md-1 gap-10 mb-6">
          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mb-6 text-center sm:text-left flex flex-col items-center sm:items-start">
            <div className="footer-widget">
              <div className="footer-logo mb-4">
                <Link to={process.env.PUBLIC_URL + "/"}>
                  <img
                    className="w-32 object-cover mx-auto sm:mx-0"
                    src={logo}
                    alt="footer logo"
                  />
                </Link>
              </div>
              <div className="footer-widget-content">
                <div className="content mb-4">
                  <p>
                    <a href="tel:+971553600937" className="text-white">
                      +971&nbsp;&nbsp;55&nbsp;&nbsp;360&nbsp;0937
                    </a>
                  </p>
                  <p>
                    <a href="mailto:info@nsmarketing.ae" className="text-white">
                      info@nsmarketing.ae
                    </a>
                  </p>
                </div>
                <div className="footer-social-inline flex gap-3 justify-center sm:justify-start">
                  <a
                    href="https://www.facebook.com/profile.php?id=61562778087870"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook-square text-white"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/nsmarketing.ae/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram text-white"></i>
                  </a>
                  <a
                    href="https://www.pinterest.com/nsmarketingco/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-pinterest text-white"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/ns-digital-marketing-ae/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-linkedin text-white"></i>
                  </a>
                  <a
                    href="https://www.tiktok.com/@ns.marketing08?_t=ZS-8wmfrjw6jFk&_r=1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-tiktok text-white"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {FooterData &&
            FooterData.map((single, key) => {
              const isLastItem = key === FooterData.length - 1;

              return (
                <div
                  key={key}
                  className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 mb-3 text-center sm:text-left"
                >
                  {!isLastItem && (
                    <div className="border-b border-white/20 pb-14 block lg:hidden">
                      <FooterLinkItem data={single} />
                    </div>
                  )}

                  {(isLastItem || true) && (
                    <div
                      className={`${!isLastItem ? "hidden" : "block"} lg:block`}
                    >
                      <FooterLinkItem data={single} />
                    </div>
                  )}
                </div>
              );
            })}
        </div>

        <div className="row">
          <div className="col">
            <p className="copyright">
              &copy; {new Date().getFullYear()}{" "}
              <span
                style={{
                  color: "#fff",
                }}
              >
                NS Marketing
              </span>
              . All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
